module.exports = __webpack_public_path__ + "static/media/yunyin_web.9801eb28.wav";